<div class="container mt-4">
	<div class="card shadow-sm">
		<div class="card-header bg-primary text-white">
			<h5 class="mb-0">{{ isEdit ? 'Edit Job' : 'Add Job' }}</h5>
		</div>
		<div class="card-body">
			<form [formGroup]="jobForm" (ngSubmit)="onSubmit()">
				<div class="row g-3">
					<ng-container *ngIf="isEdit">
						<div class="col-md-3">
							<label for="job_code" class="form-label">Job Code</label>
							<input type="text" class="form-control" id="job_code" [value]="currentJob?.job_code" disabled>
						</div>
					</ng-container>
					<div class="col-md-3">
						<label for="client_code" class="form-label">Client Code</label>
						<input type="text" class="form-control" id="client_code" formControlName="client_code" name="client_code" required [disabled]="isEdit">
					</div>
					<div class="col-md-9">
						<label for="client_name" class="form-label">Client Name</label>
						<input type="text" class="form-control" id="client_name" formControlName="client_name" name="client_name" required [disabled]="isEdit">
					</div>
					<div class="col-md-6">
						<label for="job_title" class="form-label">Job Title</label>
						<input type="text" class="form-control" id="job_title" formControlName="job_title" name="job_title" required [disabled]="isEdit" list="position-list">
						<datalist id="position-list">
							<option *ngFor="let pos of positionOptions" [value]="pos.value || pos.type">{{ pos.label || pos.type }}</option>
						</datalist>
					</div>
					<div class="col-md-12">
						<label for="description" class="form-label">Description</label>
						<textarea class="form-control" id="description" formControlName="description" name="description" rows="2"></textarea>
					</div>
					<div class="col-md-3">
						<label for="employment_type" class="form-label">Employment Type</label>
						<input type="text" class="form-control" id="employment_type" formControlName="employment_type" name="employment_type" required list="employment-type-list">
						<datalist id="employment-type-list">
							<option value="Full-Time">Full-Time</option>
							<option value="Part-Time">Part-Time</option>
							<option value="Payroll">Payroll</option>
						</datalist>
					</div>
					<div class="col-md-3">
						<label for="Agreed_Hours" class="form-label">Agreed Hours</label>
						<input type="number" class="form-control" id="Agreed_Hours" formControlName="Agreed_Hours" name="Agreed_Hours">
					</div>
					<div class="col-md-3">
						<label for="posted_date" class="form-label">Posted Date</label>
						<input type="date" class="form-control" id="posted_date" formControlName="posted_date" name="posted_date" [disabled]="true">
					</div>
					<ng-container *ngIf="isEdit">
						<div class="col-md-3">
							<label for="closing_date" class="form-label">Closing Date</label>
							<input type="date" class="form-control" id="closing_date" [value]="currentJob?.closing_date" disabled>
						</div>
					</ng-container>
					<div class="col-md-3">
						<label for="status" class="form-label">Status</label>
						<input type="text" class="form-control" id="status" formControlName="status" name="status" [disabled]="true">
					</div>
				</div>
				<div class="d-flex justify-content-end gap-2 mt-4">
					<button type="submit" class="btn btn-primary" [disabled]="jobForm.invalid">Save</button>
					<button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
				</div>
			</form>
		</div>
	</div>
</div>
